"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { Icon } from "@iconify/react";

const NAV_LINKS = [
  { href: "/#product", label: "Product" },
  { href: "/#solutions", label: "Solutions" },
  { href: "/pricing", label: "Pricing" },
  { href: "/#how-it-works", label: "How it works" },
] as const;

export function MarketingHeader() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") setOpen(false);
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);

  return (
    <header className="relative z-40 border-b border-[#2B3624]/[0.06] py-6">
      <div className="flex items-center justify-between">
        <Link href="/" className="flex items-center gap-2.5 text-[#2B3624]" aria-label="CollaboratorX home">
          <span className="text-lg font-semibold tracking-tight">CollaboratorX.ai</span>
        </Link>

        <nav className="hidden items-center gap-8 text-sm font-medium text-[#5F675B] lg:flex">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="transition-colors hover:text-[#2B3624]">
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3 sm:gap-5">
          <Link
            href="/login"
            className="hidden text-sm font-medium text-[#5F675B] transition-colors hover:text-[#2B3624] sm:block"
          >
            Sign in
          </Link>
          <Link
            href="/signup"
            className="rounded-md bg-[#2B3624] px-4 py-2.5 text-sm font-medium text-[#F6F3EC] shadow-[0_2px_3px_-1px_rgba(0,0,0,0.12),0_0_0_1px_rgba(25,28,33,0.08)] transition-colors hover:bg-[#1F281A] sm:px-5"
          >
            Start free
          </Link>
          <button
            type="button"
            aria-expanded={open}
            aria-controls="marketing-mobile-menu"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-[#2B3624]/15 text-[#2B3624] lg:hidden"
          >
            <Icon icon={open ? "solar:close-circle-linear" : "solar:hamburger-menu-linear"} className="text-xl" />
          </button>
        </div>
      </div>

      {open && (
        <nav
          id="marketing-mobile-menu"
          className="mt-4 flex flex-col gap-1 border-t border-[#2B3624]/[0.06] pt-4 text-sm font-medium text-[#5F675B] lg:hidden"
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="rounded-md px-2 py-2.5 transition-colors hover:bg-white/50 hover:text-[#2B3624]"
            >
              {link.label}
            </a>
          ))}
          <Link
            href="/login"
            onClick={() => setOpen(false)}
            className="rounded-md px-2 py-2.5 transition-colors hover:bg-white/50 hover:text-[#2B3624] sm:hidden"
          >
            Sign in
          </Link>
        </nav>
      )}
    </header>
  );
}
